/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Embed_Captions_Local_Phase_VerifyInputs */



/**
* | output |
* | --- |
* | "Verifying" |
*
* @param {Embed_Captions_Local_Phase_VerifyInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const embed_captions_local_phase_verify = /** @type {((inputs?: Embed_Captions_Local_Phase_VerifyInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Embed_Captions_Local_Phase_VerifyInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Vérification")
	if (locale === "de") return /** @type {LocalizedString} */ ("Überprüfung")
	if (locale === "it") return /** @type {LocalizedString} */ ("Verifica")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Проверка")
	if (locale === "es") return /** @type {LocalizedString} */ ("Verificando")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("核实")
	if (locale === "ja") return /** @type {LocalizedString} */ ("検証中")
	if (locale === "hi") return /** @type {LocalizedString} */ ("सत्यापन")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Verificando")
	return /** @type {LocalizedString} */ ("Verifying")
});